import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { selectDialogSize } from '../../../store/dialog/dialog.selector';
import { BootstrapDialog } from './dialog.styles';

const Dialog = ({ children }: { children: ReactNode }) => {
    const dialogSize = useSelector(selectDialogSize);

    return (
        <BootstrapDialog open={true} fullWidth maxWidth={dialogSize}>
            {children}
        </BootstrapDialog>
    );
};

export default Dialog;
